import { Datagrid, LongTextField } from "ra-friendsofbabba";
import { DateField, List as RaList, TextField } from "react-admin";

import { DownloadButton } from "../component/button";
import Filters from "./Filters";
import React from "react";

const List = (props) => {
  return (
    <RaList
      {...props}
      exporter={false}
      filters={<Filters />}
      perPage={25}
      sort={{ field: "DocFiles.modified", order: "ASC" }}
    >
      <Datagrid rowClick="edit">
        <TextField
          source="research_project.code"
          sortBy="ResearchProjects.code"
        />
        <LongTextField
          source="research_project.title"
          sortBy="ResearchProjects.title"
          maxWidth={300}
        />
        <LongTextField
          source="doc_file_type_name"
          sortable={false}
          maxWidth={300}
        />
        <DateField source="modified" sortBy="DocFiles.modified" />
        <DownloadButton />
      </Datagrid>
    </RaList>
  );
};
export default List;
